import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getTipoContrato, cadastrarTipoContrato, alterarTipoContrato, excluirTipoContrato } from '../../../api';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
var TiposContratosEditar = function () {
    var services = {
        getItem: getTipoContrato,
        cadastrarItem: cadastrarTipoContrato,
        alterarItem: alterarTipoContrato,
        excluirItem: excluirTipoContrato,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.CC_TIPOS_CONTRATOS, paginaPermissao: FUNCIONALIDADES.CC_TIPOS_CONTRATOS, rota: ROUTES.CC_TIPOS_CONTRATOS, services: services });
};
export default TiposContratosEditar;
